export default __webpack_public_path__ + "static/media/twitter-s-hover-icon.8a252ba4.svg";